export default function useApi({ user, userToken } = {}) {
  const request = async (method, path, data, token = userToken) => {
    const options = {
      method: method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data || {}),
    }

    const idToken = token || (await user?.getIdToken())

    if (idToken) {
      options.headers.Authorization = `Bearer ${idToken}`
    }

    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}${path}`,
      options,
    )

    if (!res.ok) {
      throw new Error(res.statusText)
    }

    return await res.json()
  }

  const createPaymentIntent = ({
    price,
    metadata,
    savePaymentMethod,
    paymentMethodId,
    paymentIntentId,
  }) =>
    request('POST', 'createPaymentIntent', {
      price,
      metadata,
      savePaymentMethod,
      paymentMethodId,
      paymentIntentId,
    })

  const createSetupIntent = () => request('POST', 'createSetupIntent')

  const savePaymentMethod = ({ paymentMethodId }) =>
    request('POST', 'savePaymentMethod', { paymentMethodId })

  const listSavedCards = () => request('POST', 'listSavedCards')

  const createSubscription = ({ priceId, ipAddress, token }) =>
    request('POST', 'createSubscription', { priceId, ipAddress }, token)

  const createCheckoutSession = ({ priceId, token, affiliateId }) =>
    request('POST', 'createCheckoutSession', { priceId, affiliateId }, token)

  const createFreeTranscript = ({ email, url }) =>
    request('POST', 'getTranscript', { email, url })

  const analyzeVideo = ({ url }) => request('POST', 'analyzeVideo', { url })

  const transcribeVideo = ({ email, url, language, videoInfo }) =>
    request('POST', 'transcribeVideo', { email, url, language, ...videoInfo })

  const finishOauth = ({ code }) => request('POST', 'finishOauth', { code })

  const getProducts = () => request('POST', 'getProducts')

  return {
    createPaymentIntent,
    createSetupIntent,
    savePaymentMethod,
    listSavedCards,
    createSubscription,
    createCheckoutSession,
    createFreeTranscript,
    analyzeVideo,
    transcribeVideo,
    finishOauth,
    getProducts,
  }
}
